import React__default from 'react';
import { USPList } from '@grandvisionhq/common';
import { Heading } from '@grandvisionhq/elements';
import { LocationSearch } from '@grandvisionhq/locations';
import { useIntl } from '@grandvisionhq/state';
import { Components, useStoreFinderContext, Hooks } from '@grandvisionhq/stores-v2';
import { useAddViewportHeightCssVariable } from '@grandvisionhq/utils';
import { fromStoreResultToStore } from '../../pages/BookAppointment/adapters/from-store-result-to-store.js';
import { useAppointmentContext } from '../../pages/BookAppointment/context/AppointmentContext.js';
import { useRoutingContext } from '../../pages/BookAppointment/context/RoutingContext/context.js';
import LinkedAppointmentInfo from '../LinkedAppointmentInfo/LinkedAppointmentInfoContainer.js';
import SelectedChoices from '../SelectedChoices/SelectedChoicesContainer.js';
import VirtualAppointmentButtonContainer from '../VirtualAppointmentButton/VirtualAppointmentButtonContainer.js';
import HighlightPreferredStore from './HighlightPreferredStore/HighlightPreferredStoreContainer.js';
import NoStoresAlert from './NoStoresAlert/NoStoresAlertContainer.js';
import StoreFinderItem from './StoreFinderItem/StoreFinderItemContainer.js';
import StoreFinderMap from './StoreFinderMap/StoreFinderMapContainer.js';
import StoreFinderSearchForm from './StoreFinderSearchForm/StoreFinderSearchFormContainer.js';
import useVirtualAppointment from '../../pages/BookAppointment/hooks/use-virtual-appointment.js';

const StoreListTopContent = Components.StoreListTopContent;
const StoreFinderContainer = ({ appointmentTypeId  })=>{
    const { getLabel , hasLabel  } = useIntl();
    const [{ setStore , setType  }] = useAppointmentContext();
    const [{ goTo  }] = useRoutingContext();
    const { isPristineSearch , isStoresLoading , stores , config  } = useStoreFinderContext();
    const { googleMapsId  } = config;
    const showTabs = Hooks.useTabs();
    const [{ getAppointmentTypeData , getStoreData  }, { enabled: isVirtualAppointmentEnabled  }] = useVirtualAppointment();
    // Run this only once.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const virtualAppointment = React__default.useMemo(()=>getAppointmentTypeData()
    , []);
    const onClickVirtualAppointmentType = React__default.useCallback((type)=>{
        const store = getStoreData(undefined, type);
        if (!type || !store) {
            return;
        }
        setType(type);
        setStore(store);
        const typeId = type.id;
        const storeId = `${store.code}`;
        goTo('when', {
            typeId,
            storeId
        });
    }, [
        getStoreData,
        setType,
        setStore,
        goTo
    ]);
    const storeListTopContent = /*#__PURE__*/ React__default.createElement(React__default.Fragment, null, /*#__PURE__*/ React__default.createElement("div", {
        className: "appointments-store-finder__selected-choices"
    }, /*#__PURE__*/ React__default.createElement(SelectedChoices, null)), /*#__PURE__*/ React__default.createElement(LinkedAppointmentInfo, {
        className: "appointments-store-finder__linked-appointment-type"
    }), /*#__PURE__*/ React__default.createElement(StoreListTopContent, {
        title: getLabel('appointments.component.storeFinder.title'),
        description: hasLabel('appointments.component.storeFinder.description') ? getLabel('appointments.component.storeFinder.description') : undefined
    }));
    const uspList = /*#__PURE__*/ React__default.createElement("div", {
        className: "appointments-store-finder__usp-list"
    }, /*#__PURE__*/ React__default.createElement(USPList, {
        usps: [
            'appointments.component.storeFinder.usp1',
            'appointments.component.storeFinder.usp2',
            'appointments.component.storeFinder.usp3', 
        ]
    }));
    const showNoStoresAlert = !isPristineSearch && !isStoresLoading && stores.length === 0;
    const showVirtualAppointmentButton = isVirtualAppointmentEnabled && !isStoresLoading && stores.length === 0;
    const showUSPs = !isVirtualAppointmentEnabled && !isStoresLoading && stores.length === 0;
    const storeListInfoContent = /*#__PURE__*/ React__default.createElement(React__default.Fragment, null, showNoStoresAlert ? /*#__PURE__*/ React__default.createElement("div", {
        className: "appointments-store-finder__info-content"
    }, /*#__PURE__*/ React__default.createElement(NoStoresAlert, null)) : null, showVirtualAppointmentButton ? /*#__PURE__*/ React__default.createElement("div", {
        className: "appointments-store-finder__info-content"
    }, /*#__PURE__*/ React__default.createElement(Heading, {
        variant: "subheading1"
    }, getLabel('appointments.component.virtualAppointmentButton.title')), /*#__PURE__*/ React__default.createElement(VirtualAppointmentButtonContainer, {
        "data-t": "virtualAppointment",
        appointmentType: virtualAppointment,
        onClick: onClickVirtualAppointmentType
    })) : null, showUSPs ? uspList : null);
    // Add css variable var(--vh) to document
    useAddViewportHeightCssVariable();
    return /*#__PURE__*/ React__default.createElement(LocationSearch, {
        className: "appointments-store-finder",
        googleMapsId: googleMapsId,
        showTabs: showTabs,
        searchForm: /*#__PURE__*/ React__default.createElement(StoreFinderSearchForm, {
            appointmentTypeId: appointmentTypeId
        }),
        listTopContent: storeListTopContent,
        listInfoContent: storeListInfoContent,
        loadingListItems: isStoresLoading,
        listItems: stores.length ? stores.map((store)=>/*#__PURE__*/ React__default.createElement(StoreFinderItem, {
                key: store.code,
                variant: "list-item",
                store: fromStoreResultToStore(store),
                "data-t": "searchResults"
            })
        ) : [],
        mapContent: /*#__PURE__*/ React__default.createElement(StoreFinderMap, {
            stores: stores,
            googleMapsId: googleMapsId
        }),
        highlightPreferredStore: /*#__PURE__*/ React__default.createElement(HighlightPreferredStore, {
            applicableAppointmentTypeId: appointmentTypeId
        })
    });
};
var StoreFinder = StoreFinderContainer;

export { StoreFinder as default };
//# sourceMappingURL=StoreFinderContainer.js.map
